
import "./howitworks.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useEffect } from "react";

/* imagens */
import howitworks1 from "../../assets/howitworks1.png";
import howitworks2 from "../../assets/howitworks2.png";
import howitworks3 from "../../assets/howitworks3.png";
import howitworks4 from "../../assets/howitworks4.png";
import howitworks5 from "../../assets/howitworks5.png";
import howitworks6 from "../../assets/howitworks6.png";
import howitworks7 from "../../assets/howitworks7.png";

import howitworks1_mobile from "../../assets/howitworks1-mobile.png";
import howitworks2_mobile from "../../assets/howitworks2-mobile.png";
import howitworks3_mobile from "../../assets/howitworks3-mobile.png";
import howitworks4_mobile from "../../assets/howitworks4-mobile.png";
import howitworks5_mobile from "../../assets/howitworks5-mobile.png";


export default function Howitworks() {

    useEffect(() => { window.scrollTo(0, 0); }, []);

        return(
        <div className="context">
                    
            <Header access={0}></Header>
            
            <div className="content">
                <span className="ft_topico">Crie seu agente em quatro passos, veja como é simples ...</span>
                <span className="ft_descricao">Seguindo esses quatro passos abaixo, você cria seu agente e poderá testá-lo de imediato.</span>
                <span className="ft_descricao">Você não precisa de nenhum conhecimento técnico ou específico, basta seguir os passos e preencher com as informações que você já possui sobre seu ramo de atividade e características da sua prestação de serviços.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="howitworks_numbers"><span className="howitworks_hashtag">#</span>1</span>
                <div className="howitworks_box1">
                    <img className="howitworks_image1" src={howitworks1}></img>
                    <img className="howitworks_image1-mobile" src={howitworks1_mobile}></img>
                    <img className="howitworks_image2" src={howitworks2}></img>
                    <img className="howitworks_image2-mobile" src={howitworks2_mobile}></img>
                </div>
                <span className="ft_descricao">Na Barra de Menu, acesse "Entrar" e depois "Quero me Cadastrar".</span>
                <span className="ft_descricao">Faça seu cadastro com pouquíssimas informações, ao final, será criada sua conta, onde através dela você poderá acessar a nossa plataforma.</span>

                <span className="space"></span>
                <span className="space"></span>
                <span className="howitworks_numbers"><span className="howitworks_hashtag">#</span>2</span>
                <img className="howitworks_image3" src={howitworks3}></img>
                <img className="howitworks_image3-mobile" src={howitworks3_mobile}></img>
                <span className="ft_descricao">Entre com seu email e a senha que você definiu. Pronto, você já acessará a plataforma</span>

                <span className="space"></span>
                <span className="space"></span>
                <span className="howitworks_numbers"><span className="howitworks_hashtag">#</span>3</span>
                <div className="howitworks_box1">
                    <img className="howitworks_image4" src={howitworks4}></img>
                    <img className="howitworks_image4-mobile" src={howitworks4_mobile}></img>
                    <img className="howitworks_image5" src={howitworks5}></img>
                    <img className="howitworks_image5-mobile" src={howitworks5_mobile}></img>
                </div>
                <span className="ft_descricao">Ao acessar a nossa plataforma, você estará no Painel do cliente, clique em "Criar Agente".</span>
                <span className="ft_descricao">Na tela de criação do agente, basta dar um nome a ele e escolher o plano que melhor atende a sua necessidade.</span>
                <span className="ft_descricao">Pronto, agente criado ...</span>

                <span className="space"></span>
                <span className="space"></span>
                <span className="howitworks_numbers"><span className="howitworks_hashtag">#</span>4</span>
                <div className="howitworks_box1">
                    <img className="howitworks_image6" src={howitworks6}></img>
                    <img className="howitworks_image7" src={howitworks7}></img>
                </div>
                <span className="ft_descricao">E para finalizar, após criar seu agente, você vai configurá-lo de acordo com o plano que você escolheu.</span>
                <span className="ft_descricao">Cada plano possui características próprias, basta você preencher as informações conforme são solicitadas nas telas.</span>
                <span className="ft_descricao">Quanto mais informações você preencher, mais completo ficará seu agente.</span>
                <span className="space"></span>
                <span className="ft_descricao">Ao concluir a configuração, nós lhe daremos um número de linha onde seu agente funcionará.</span>
                <span className="ft_descricao">envie um <span style={{color: "var(--SEC_2)"}}>"oi"</span> para seu agente e começe a explorar todo o potêncial que ele possui para prestar atendimento a seus clientes.</span>
                
                <span className="space"></span>
                <span className="howitworks_text1">Você tem 7 dias gratuítos para testar seu agente</span>

                <span className="space"></span>
                <span className="howitworks_note">Importante:</span>
                <span className="howitworks_note">A criação de agentes depende de api's que eventualmente poderão estar fora de serviço, mas seus dados serão registrados para que possamos criá-lo brevemente possível;</span>
                <span className="howitworks_note">Além de um número de linha telefônica que será alocado para seu agente, ele também terá acesso a uma agenda exclusiva (via plataforma);</span>
                <span className="howitworks_note">Após sete dias sem a contratação da assinatura, sua linha será disponibilizada.</span>

                <span className="space"></span>
                <span className="space"></span>
                <span className="space"></span>
            </div>
            
            <Footer access={0}></Footer>

        </div>
    )
}